// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1PnvD","errorLogs":"styles_errorLogs__1iynx"};